import { performGetRequest } from '@atlassian/jira-fetch';

export const getCodeFeatureState = (projectId: number): Promise<boolean> =>
	performGetRequest(`/rest/projects/1.0/codelink/${projectId}/is_enabled`);
